export default __webpack_public_path__ + "static/media/fd.caa121e1.png";